import { Component, DestroyRef, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastService } from '../../services/toast/toast.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-toast',
    imports: [
      CommonModule,
    ],
    templateUrl: './toast.component.html',
    styleUrls: ['./toast.component.css'],
})
export class ToastComponent implements OnInit {
  isVisible = false;
  title = '';
  message = '';
  type: 'success' | 'error' | 'info' | 'warning' = 'success';
  duration = 3000;
  progressWidth = 100;
  private destroyRef = inject(DestroyRef);

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.toastService.toastState
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((toast) => {
      this.title = toast.title;
      this.message = toast.message;
      this.type = toast.type;
      this.duration = toast.duration;
      this.progressWidth = 100;
      this.showToast();
    });
  }

  showToast(): void {
    this.isVisible = true;

    // Start the progress bar decrement
    const interval = 10; // ms
    const decrement = (interval / this.duration) * 100;
    const progressInterval = setInterval(() => {
      this.progressWidth -= decrement;
      if (this.progressWidth <= 0) {
        clearInterval(progressInterval);
        this.isVisible = false;
      }
    }, interval);
  }

  dismissToast(): void {
    this.isVisible = false;
  }
}

